(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["project-q-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeProjectQVideoHero = (root) => {
    if (!root || root.dataset.videoInitialized === 'true') return;
    root.dataset.videoInitialized = 'true';

    const videos = Array.from(root.querySelectorAll('video'));
    const toggle = root.querySelector('[data-video-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setPausedState = (paused) => {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      toggle.setAttribute('aria-label', paused ? window.ProjectQI18n.play_background : window.ProjectQI18n.pause_background);
    };

    const pauseVideos = () => {
      videos.forEach((video) => video.pause());
      setPausedState(true);
    };

    const playVideos = () => {
      videos.forEach((video) => {
        const result = video.play();
        if (result && typeof result.catch === 'function') result.catch(() => setPausedState(true));
      });
      setPausedState(false);
    };

    if (reduceMotion.matches) pauseVideos();

    toggle?.addEventListener('click', () => {
      const isPaused = toggle.getAttribute('aria-pressed') === 'true';
      if (isPaused) playVideos();
      else pauseVideos();
    });

    reduceMotion.addEventListener?.('change', (event) => {
      if (event.matches) pauseVideos();
    });
  };

  document.querySelectorAll('[data-project-q-video-hero]').forEach(initializeProjectQVideoHero);

  document.addEventListener('shopify:section:load', (event) => {
    initializeProjectQVideoHero(event.target.querySelector('[data-project-q-video-hero]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-q-main-collection-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const keys = ['brand', 'joint', 'shaft', 'tip', 'length', 'weight', 'butt'];
  const queryName = key => `pq_${key}`;
  const init = scope => scope.querySelectorAll('[data-pqgb-catalog]').forEach(root => {
    if (root.dataset.pqgbReady) return;
    root.dataset.pqgbReady = 'true';
    const cards = [...root.querySelectorAll('[data-pqgb-card]')];
    const panel = root.querySelector('[data-pqgb-filters]');
    const nativeForm = root.querySelector('[data-pqgb-native-form]');
    const sortForm = root.querySelector('[data-pqgb-sort-form]');
    const extra = root.querySelector('[data-pqgb-extra-filters]');
    const noResults = root.querySelector('[data-pqgb-no-results]');
    const count = root.querySelector('[data-pqgb-count]');
    const backdrop = root.querySelector('[data-pqgb-close]');
    const desktop = matchMedia('(min-width: 990px)');
    const complete = Number(root.dataset.productCount) <= 50;
    const active = new Map(keys.map(key => [key, new Set()]));
    const valueOf = (card, key) => (card.getAttribute(`data-pqgb-${key}`) || '').trim();
    const nativeBrand = root.querySelector('[data-pqgb-native-facet="filter.p.vendor"]');
    if (nativeBrand) nativeForm.insertBefore(nativeBrand, extra);
    const syncFormState = () => {
      sortForm.querySelectorAll('[data-pqgb-query]').forEach(input => input.remove());
      keys.forEach(key => active.get(key).forEach(value => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = queryName(key); input.value = value;
        input.dataset.pqgbQuery = 'true'; sortForm.append(input);
      }));
    };
    const matches = (card, except) => keys.every(key => key === except || !active.get(key).size || active.get(key).has(valueOf(card, key)));
    const apply = updateUrl => {
      let visible = 0;
      cards.forEach(card => { card.hidden = !matches(card); if (!card.hidden) visible += 1; });
      if (count) count.textContent = (root.dataset.countLabel || '__COUNT__').replace('__COUNT__', String(visible));
      if (noResults) noResults.hidden = visible > 0 || cards.length === 0;
      extra.querySelectorAll('input[data-pqgb-key]').forEach(input => {
        const key = input.dataset.pqgbKey;
        const amount = cards.filter(card => valueOf(card, key) === input.value && matches(card, key)).length;
        input.disabled = amount === 0 && !input.checked;
        input.parentElement.querySelector('[data-pqgb-option-count]').textContent = String(amount);
      });
      syncFormState();
      if (updateUrl) {
        const url = new URL(location.href);
        keys.forEach(key => { url.searchParams.delete(queryName(key)); active.get(key).forEach(value => url.searchParams.append(queryName(key), value)); });
        url.searchParams.delete('page');
        history.pushState(null, '', url);
      }
    };
    const restore = () => {
      const url = new URL(location.href);
      keys.forEach(key => active.set(key, new Set(url.searchParams.getAll(queryName(key)))));
      extra.querySelectorAll('input[data-pqgb-key]').forEach(input => { input.checked = active.get(input.dataset.pqgbKey).has(input.value); });
      apply(false);
    };
    if (complete) {
      const url = new URL(location.href);
      keys.forEach(key => {
        const facet = extra.querySelector(`[data-pqgb-facet="${key}"]`);
        if (key === 'brand' && nativeBrand) return;
        const values = new Set(cards.map(card => valueOf(card,key)).filter(Boolean));
        url.searchParams.getAll(queryName(key)).forEach(value => values.add(value));
        if (!values.size) return;
        const target = facet.querySelector('[data-pqgb-values]');
        [...values].sort((a,b) => a.localeCompare(b, 'zh-Hant', { numeric: true })).forEach(value => {
          const label = document.createElement('label');
          const input = document.createElement('input');
          input.type='checkbox'; input.name=queryName(key); input.value=value; input.dataset.pqgbKey=key;
          const text=document.createElement('span'); text.textContent=value+(facet.dataset.unit?' '+facet.dataset.unit:'');
          const optionCount=document.createElement('span'); optionCount.dataset.pqgbOptionCount='true'; optionCount.className='pqgb-collection__filter-count';
          label.append(input,text,optionCount); target.append(label);
        });
        facet.hidden=false;
        facet.open=url.searchParams.has(queryName(key));
      });
      extra.hidden=false;
      extra.addEventListener('change',event => {
        const input=event.target.closest('input[data-pqgb-key]'); if(!input) return;
        const selected=active.get(input.dataset.pqgbKey);
        if(input.checked) selected.add(input.value); else selected.delete(input.value);
        apply(true);
      });
      restore();
      window.addEventListener('popstate', restore);
    }
    let savedOverflow = null;
    const setModal = () => {
      const modal = panel.open && !desktop.matches;
      backdrop.hidden = !modal;
      if (modal) {
        panel.setAttribute('role','dialog'); panel.setAttribute('aria-modal','true');
        panel.setAttribute('aria-label', panel.querySelector('summary').textContent.trim());
        if(savedOverflow === null) { savedOverflow = document.body.style.overflow; document.body.style.overflow='hidden'; }
      } else {
        panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); panel.removeAttribute('aria-label');
        if(savedOverflow !== null) { document.body.style.overflow=savedOverflow; savedOverflow=null; }
      }
    };
    const close = () => { panel.open=false; setModal(); panel.querySelector('summary').focus(); };
    panel.open=desktop.matches;
    panel.addEventListener('toggle',setModal);
    backdrop.addEventListener('click',close);
    panel.addEventListener('keydown',event => {
      if(desktop.matches || !panel.open) return;
      if(event.key==='Escape') { event.preventDefault(); close(); }
      if(event.key==='Tab') {
        const nodes=[...panel.querySelectorAll('summary,a[href],button,input,select')].filter(node=>!node.disabled && node.getClientRects().length);
        const first=nodes[0],last=nodes[nodes.length-1];
        if(event.shiftKey && document.activeElement===first) { event.preventDefault(); last.focus(); }
        else if(!event.shiftKey && document.activeElement===last) { event.preventDefault(); first.focus(); }
      }
    });
    desktop.addEventListener('change',()=>{panel.open=desktop.matches;setModal();});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){panel.open=false;setModal();window.removeEventListener('popstate',restore);}});
    setModal();
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true}); else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-q-main-product-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initProducts(scope) {
    scope.querySelectorAll('[data-pqv2-pdp]').forEach((root) => {
      if (root.dataset.pqv2Ready === 'true') return;
      root.dataset.pqv2Ready = 'true';
      const stockPending = root.dataset.stockPending === 'true';
      if (stockPending) root.querySelector('.pqv2-form')?.addEventListener('submit', (event) => event.preventDefault());
      const track = root.querySelector('[data-pqv2-track]');
      const slides = track ? [...track.children] : [];
      const current = root.querySelector('[data-pqv2-current]');
      const mediaNavigation = root.querySelectorAll('[data-pqv2-media-target]');
      function syncMedia(index) {
        const activeSlide = slides[index];
        if (!activeSlide) return;
        if (current) current.textContent = String(index + 1);
        slides.forEach((slide, i) => {
          if (i !== index) slide.querySelectorAll('video').forEach((video) => video.pause());
        });
        mediaNavigation.forEach((button) => {
          const selected = button.dataset.pqv2MediaKind === 'image' ? activeSlide.dataset.mediaType === 'image' : button.dataset.pqv2MediaTarget === activeSlide.dataset.mediaId;
          button.setAttribute('aria-pressed', String(selected));
        });
      }
      if (track) {
        let ticking = false;
        track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            let index = 0;
            let distance = Infinity;
            slides.forEach((slide, i) => {
              const d = Math.abs(slide.getBoundingClientRect().left - track.getBoundingClientRect().left);
              if (d < distance) { distance = d; index = i; }
            });
            syncMedia(index);
            ticking = false;
          });
        }, { passive: true });
      }
      mediaNavigation.forEach((button) => button.addEventListener('click', () => {
        const index = slides.findIndex((slide) => slide.dataset.mediaId === button.dataset.pqv2MediaTarget);
        if (!track || index < 0) return;
        const left = slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        track.scrollTo({ left, behavior: 'instant' });
        syncMedia(index);
      }));
      root.querySelectorAll('.pqv2-gallery__slide video').forEach((video) => video.addEventListener('play', () => {
        root.querySelectorAll('.pqv2-gallery__slide video').forEach((other) => {
          if (other !== video) other.pause();
        });
      }));
      const dialog = root.querySelector('[data-pqv2-dialog]');
      const image = root.querySelector('[data-pqv2-image]');
      root.querySelectorAll('[data-pqv2-zoom]').forEach((button) => button.addEventListener('click', () => {
        if (!dialog || !image) return;
        image.src = button.dataset.src;
        image.classList.remove('is-zoomed');
        dialog.showModal();
      }));
      root.querySelector('[data-pqv2-close]')?.addEventListener('click', () => dialog?.close());
      image?.addEventListener('click', () => image.classList.toggle('is-zoomed'));
      const select = root.querySelector('[data-pqv2-variant]');
      const price = root.querySelector('[data-pqv2-price]');
      const add = root.querySelector('[data-pqv2-add]');
      const qty = root.querySelector('[data-pqv2-qty]');
      const choices = root.querySelectorAll('[data-pqv2-variant-choice]');
      function syncVariant(updateUrl, updateMedia = true) {
        const option = select?.selectedOptions[0];
        if (!option) return;
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        const available = !stockPending && option.dataset.available === 'true';
        if (add) {
          add.disabled = !available;
          add.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
        }
        if (qty) {
          qty.disabled = !available;
          if (!stockPending && option.dataset.quantityLimit) qty.max = option.dataset.quantityLimit;
          else qty.removeAttribute('max');
        }
        const stockHint = root.querySelector('[data-pqv2-stock-hint]');
        if (stockHint) {
          stockHint.hidden = stockPending ? false : !option.dataset.quantityLimit;
          stockHint.textContent = stockPending ? root.dataset.stockPendingHint : option.dataset.stockHint || '';
        }
        const supplyStatus = root.querySelector('[data-pq-supply-state]');
        const supplyLabel = root.querySelector('[data-pq-supply-label]');
        if (supplyStatus && supplyLabel && option.dataset.supplyState) {
          supplyStatus.dataset.pqSupplyState = option.dataset.supplyState;
          supplyLabel.textContent = option.dataset.supplyLabel || '';
        }
        choices.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.pqv2VariantChoice === option.value)));
        const slide = slides.find((item) => item.dataset.mediaId === option.dataset.mediaId);
        if (updateMedia && track && slide) {
          const left = slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          track.scrollTo({ left, behavior: 'instant' });
          syncMedia(slides.indexOf(slide));
        }
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState(window.history.state, '', url);
        }
        if (root.dataset.whatsappPhone) {
          const productUrl = new URL(root.dataset.productUrl, window.location.origin);
          productUrl.searchParams.set('variant', option.value);
          const message = `${root.dataset.whatsappMessage}【${root.dataset.productTitle} — ${option.dataset.title}】 ${productUrl.href}`;
          root.querySelectorAll('[data-pqv2-whatsapp]').forEach((link) => {
            link.href = `https://wa.me/${root.dataset.whatsappPhone}?text=${encodeURIComponent(message)}`;
          });
        }
      }
      select?.addEventListener('change', () => syncVariant(true));
      choices.forEach((button) => button.addEventListener('click', () => {
        if (!select) return;
        select.value = button.dataset.pqv2VariantChoice;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      if (select && choices.length) root.classList.add('pqv2-pdp--enhanced');
      const requestedVariant = new URL(window.location.href).searchParams.get('variant');
      syncVariant(false, root.dataset.variantImages === 'true' || requestedVariant === select?.value);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initProducts(document), { once: true });
  else initProducts(document);
  document.addEventListener('shopify:section:load', (event) => initProducts(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
